import type { Project } from '@/types/nest/projects'
import { computed, ref, type Ref } from 'vue'

export function useProjectValidation(project: Ref<Project | null>) {
  const submitted = ref(false)

  const errors = computed(() => {
    const data = project.value
    const result: Partial<Record<keyof Project, string>> = {}

    if (!data) {
      return result
    }

    if (data.name?.trim().length === 0) {
      result.name = 'Name cannot be empty'
    }

    return result
  })

  const visibleErrors = computed<Partial<Record<keyof Project, string>>>(() => {
    if (!submitted.value) return {}
    return errors.value
  })

  const isValid = computed(() => Object.keys(errors.value).length === 0)
  const isSubmittedAndInvalid = computed(() => submitted.value && !isValid.value)

  function validate(): boolean {
    submitted.value = true
    return isValid.value
  }

  return { errors, visibleErrors, isValid, isSubmittedAndInvalid, submitted, validate }
}
